// The bug-report route (C-33: network I/O lives in `services/` or `lib/apiClient`). The
// `fetch` its call site made, moved here unchanged and returning the `Response` untouched
// (the caller reads the body's `ok` and the `x-request-id` header).
import { intentHeaders as rawIntentHeaders } from "../lib/telemetry/intentEmitter.js";

/** `x-intent-id` for `intentId`, or no header (the emitter is JS; typed here for `fetch`). */
const intentHeaders = (intentId: string | null): Record<string, string> =>
  rawIntentHeaders(intentId) as Record<string, string>;

const JSON_HEADERS = { "Content-Type": "application/json" };

/**
 * The report body. A retry of an attempt the server answered 503 `{ok:false, bug_id,
 * retry_token}` carries that pair back as `retry_of` / `retry_token`, so the server reuses the
 * id its bundles already sit under (ignored unless the token verifies).
 */
export type BugReportBody = Record<string, unknown> & {
  retry_of?: string;
  retry_token?: string;
};

/** `POST /api/bug-report` with the report and the intent that filed it. */
export function postBugReport(
  body: BugReportBody,
  { intentId = null }: { intentId?: string | null } = {},
): Promise<Response> {
  return fetch("/api/bug-report", {
    method: "POST",
    headers: { ...JSON_HEADERS, ...intentHeaders(intentId) },
    body: JSON.stringify(body),
  });
}
